<template>
  <div class="typeArea box">
    <div class="list">
      <div class="item item-right">
        <defaultImg :src="require('@/assets/images/image173.png')"></defaultImg>
        <div class="detail">
          <div class="detail-line1">农药登记试验</div>
          <div class="detail-line2">农药登记试验在农药管理中有着极其重要的作用，事关农业生产安全、农产品质量安全、生态环境安全。贵州健安德核心团队深耕行业20年，累计完成试验10000余项，多次参与国家标准、行业标准制定，拥有非常丰富的经验。试验资质范围覆盖产品化学、毒理学、环境影响等领域，已累计为500多家农药企业提供服务。</div>
          <!-- <div class="detail-line3">服务600+家农药企业、1000+项试验。</div> -->
          <div class="detail-line4" @click="$router.push('/ourService/ourServicePesticide')">了解更多</div>
        </div>
      </div>
      <div class="item item-left">
        <defaultImg :src="require('@/assets/images/image174.png')"></defaultImg>
        <div class="detail">
          <div class="detail-line1">新化学物质登记试验</div>
          <div class="detail-line2">新化学物质登记试验在新化学物质环境风险管理中有着极其重要的作用，聚焦对环境和健康可能造成较大风险的新化学物质，保护生态环境，保障公众健康。贵州健安德是国内首批从事新化学物质登记试验单位，拥有非常丰富的经验。试验资质范围覆盖物理化学性质、生态毒理、健康毒理三大领域，已累计为苹果、拜耳等全球200多家企业提供服务。</div>
          <!-- <div class="detail-line3">资质覆盖理化、健康毒理学、生态毒理学。</div> -->
          <div class="detail-line4" @click="$router.push('/ourService/chemicalRegister')">了解更多</div>
        </div>
      </div>
      <div class="item item-right">
        <defaultImg :src="require('@/assets/images/image175.png')"></defaultImg>
        <div class="detail">
          <div class="detail-line1">化妆品注册和备案检验</div>
          <div class="detail-line2">为了规范化妆品生产经营活动，加强化妆品监督管理，保证化妆品质量安全，保障消费者健康，促进化妆品产业健康发展，化妆品新产品需向药监局提供注册备案检验。贵州健安德拥有专业的技术团队，丰富的行业经验，可同时提供理化、微生物、毒理学、功效、安全评价报告等一站式检测服务，助力化妆品行业健康发展。</div>
          <!-- <div class="detail-line3">提供一站式检测服务。</div> -->
          <div class="detail-line4" @click="$router.push('/ourService/makeUp')">了解更多</div>
        </div>
      </div>
      <div class="item item-left">
        <defaultImg :src="require('@/assets/images/image176.png')"></defaultImg>
        <div class="detail">
          <div class="detail-line1">其他服务</div>
          <div class="detail-line2">药物发现、化学品物理危险性鉴定与分类管理、农药产品质量检测、保健食品检验与评价、消毒产品检验等多领域服务。</div>
          <!-- <div class="detail-line3">保健食品检验与评价、消毒产品检验等多领域服务</div> -->
          <div class="detail-line4" @click="$router.push('/ourService/otherService')">了解更多</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ourServiceMainPage',
  data () {
    return {}
  },
  methods: {},
}
</script> 

<style lang='less' scoped>
  .box{
    padding-bottom: 80px;
    .list{
      .item-left{
        flex-direction: row-reverse;
        .detail{
          flex-grow: 1;
          padding-left: 0px;
        }
      }
      .item-right{
        .detail{
          padding-left: 60px;
        }
      }
      .item{
        display: flex;
        align-items: center;
        &:hover{
          img{
            transform: scale(.95);
            transition: .4s all ease;
          }
          .detail{
            .detail-line1{
              color: #DB0000;
            }
            .detail-line4{
              background-color: #DB0000;
              color: white;
            }
          }
        }
        img{
          transition: .4s all ease;
        }
        .detail{
          color: #333333;
          .detail-line1{
            font-size: 36px;
            font-weight: bold;
          }
          .detail-line2{
            margin-top: 33px;
            font-size: 14px;
            line-height: 25px;
            font-size: 16px;
            width: 680px;
          }
          .detail-line3{
            margin-top: 3px;
            font-size: 14px;
          }
          .detail-line4{
            width: 110px;
            height: 28px;
            line-height: 28px;
            border: 1px solid #DB0000;
            border-radius: 5px;
            color: #DB0000;
            text-align: center;
            font-size: 14px;
            font-weight: bold;
            cursor: pointer;
            margin-top: 43px;
          }
        }
      }
    }
  }
</style>
